/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Additionalnotes1Inputs */

const en__field_additionalnotes1 = /** @type {(inputs: _Field_Additionalnotes1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Additional Notes`)
};

const de__field_additionalnotes1 = /** @type {(inputs: _Field_Additionalnotes1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmerkungen`)
};

/**
* | output |
* | --- |
* | "Additional Notes" |
*
* @param {_Field_Additionalnotes1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_additionalnotes1 = /** @type {((inputs?: _Field_Additionalnotes1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Additionalnotes1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_additionalnotes1(inputs)
	return de__field_additionalnotes1(inputs)
});
export { _field_additionalnotes1 as "_field_additionalNotes" }